const translations = {};

translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "Passwords do not match.";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] =
  "Please enter a password of 6 characters or more.";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "A new version of the app is available.\nAn update is required to use the latest features.\nThe update will complete shortly.";
translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "Updating the app to the latest version.";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "Type a message...";
translations["MSG_ASSISTANT_SEND"] = "Send";
translations["MSG_BACK_BTN"] = "Back";
translations["MSG_BACK_BTN_BY_PARENT"] = "Back";
translations["MSG_BIRTHDAY_DAY_SUFFIX_BY_PARENT"] = "";
translations["MSG_BIRTHDAY_MONTH_SUFFIX_BY_PARENT"] = "";
translations["MSG_BIRTHDAY_YEAR_SUFFIX_BY_PARENT"] = "";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "Please enter within %{limit} characters.";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT_BY_PARENT"] = "%{limit} characters max";
translations["MSG_BODY_TYPE_CHUBBY_BY_PARENT"] = "Chubby";
translations["MSG_BODY_TYPE_MEDIUM_BY_PARENT"] = "Medium";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY_BY_PARENT"] = "Slightly Chubby";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN_BY_PARENT"] = "Slightly Thin";
translations["MSG_BODY_TYPE_THIN_BY_PARENT"] = "Thin";
translations["MSG_BODY_TYPE_TITLE_BY_PARENT"] = "Body Type";
translations["MSG_BOYS_COUNT"] = "Boys";
translations["MSG_BTN_CLOSE"] = "Close";
translations["MSG_BTN_LATER"] = "Later";
translations["MSG_CANCEL_BTN"] = "Cancel";
translations["MSG_CANCEL_BTN_BY_PARENT"] = "Cancel";
translations["MSG_CITY_TITLE"] = "City";
translations["MSG_COLOR_BLUE_BY_PARENT"] = "Blue";
translations["MSG_COLOR_GREEN_BY_PARENT"] = "Green";
translations["MSG_COLOR_OTHER_PLACEHOLDER_BY_PARENT"] = "Enter other color";
translations["MSG_COLOR_RED_BY_PARENT"] = "Red";
translations["MSG_COLOR_SELECT_SHADE"] = "Choose a shade you like";
translations["MSG_COLOR_WHITE_BY_PARENT"] = "White";
translations["MSG_COLOR_YELLOW_BY_PARENT"] = "Yellow";
translations["MSG_COMPANY_SIZE_ENTERPRISE"] = "1001+ people";
translations["MSG_COMPANY_SIZE_LARGE"] = "301-1000 people";
translations["MSG_COMPANY_SIZE_MEDIUM"] = "51-300 people";
translations["MSG_COMPANY_SIZE_MICRO"] = "1-10 people";
translations["MSG_COMPANY_SIZE_SMALL"] = "11-50 people";
translations["MSG_COMPANY_SIZE_SOLO"] = "Sole proprietor";
translations["MSG_COMPANY_SIZE_TITLE"] = "Company Size";
translations["MSG_CONFIRM_BTN_BY_PARENT"] = "Confirm";
translations["MSG_COURSE_ALGORITHM"] = "Learn Algorithm!";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "Algorithm Advanced";
translations["MSG_COURSE_GROUP_WORK"] = "Group Work";
translations["MSG_COURSE_PROGRAM"] = "First Programming";
translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "Select Course";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "Select Stage";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "Select Level";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "Stage";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "Level";
translations["MSG_ERROR_NETWORK"] = "Network error";
translations["MSG_FACE_SHAPE_OBLONG_BY_PARENT"] = "Oblong";
translations["MSG_FACE_SHAPE_OVAL_BY_PARENT"] = "Oval";
translations["MSG_FACE_SHAPE_ROUND_BY_PARENT"] = "Round";
translations["MSG_FACE_SHAPE_SQUARE_BY_PARENT"] = "Square";
translations["MSG_FACE_SHAPE_TITLE_BY_PARENT"] = "Face Shape";
translations["MSG_FACE_SHAPE_TRIANGLE_BY_PARENT"] = "Triangle";
translations["MSG_GENDER_FEMALE_BY_PARENT"] = "Girl";
translations["MSG_GENDER_MALE_BY_PARENT"] = "Boy";
translations["MSG_GENDER_NONE"] = "None";
translations["MSG_GENERATE_BTN_BY_PARENT"] = "Generate";
translations["MSG_GIRLS_COUNT"] = "Girls";
translations["MSG_GLASSES_NONE_BY_PARENT"] = "None";
translations["MSG_GLASSES_TITLE_BY_PARENT"] = "Glasses";
translations["MSG_GLASSES_YES_BY_PARENT"] = "Yes";
translations["MSG_HAIRSTYLE_LONG_BY_PARENT"] = "Long";
translations["MSG_HAIRSTYLE_MEDIUM_BY_PARENT"] = "Medium";
translations["MSG_HAIRSTYLE_SHORT_BY_PARENT"] = "Short";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG_BY_PARENT"] = "Slightly Long";
translations["MSG_HAIRSTYLE_TITLE_BY_PARENT"] = "Hairstyle";
translations["MSG_HAIRSTYLE_VERY_SHORT_BY_PARENT"] = "Very Short";
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "Household Members";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "Father";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "Grandfather";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "Grandmother";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "Mother";
translations["MSG_ICON_CATEGORY_ALL"] = "All";
translations["MSG_ICON_CATEGORY_BOY_BY_PARENT"] = "Boy";
translations["MSG_ICON_CATEGORY_GIRL_BY_PARENT"] = "Girl";
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "Current";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "Selected";
translations["MSG_ICON_CONFIRM_BTN_BY_PARENT"] = "Looks Good";
translations["MSG_ICON_CONFIRM_PROMPT_BY_PARENT"] = "Is this icon okay?";
translations["MSG_ICON_GENERATING_BY_PARENT"] = "Creating icon...";
translations["MSG_ICON_REGENERATE_BTN_BY_PARENT"] = "Create Again";
translations["MSG_ICON_CREATE_BTN"] = "Create";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "Add something if you want";
translations["MSG_ICON_SELECT_PROFILE_AI_BY_PARENT"] = "Create with AI\nfrom your\nprofile";
translations["MSG_ICON_SELECT_SYSTEM_BY_PARENT"] = "Preset\nicons";
translations["MSG_ICON_SELECT_TITLE_BY_PARENT"] = "Choose an icon for your child";
translations["MSG_ICON_SELECT_UPLOAD_BY_PARENT"] = "Upload\nimage";
translations["MSG_INDUSTRY_TITLE"] = "Industry";
translations["MSG_INDUSTRY_IT"] = "IT/Communications";
translations["MSG_INDUSTRY_MANUFACTURING"] = "Manufacturing";
translations["MSG_INDUSTRY_FINANCE"] = "Finance/Insurance";
translations["MSG_INDUSTRY_RETAIL"] = "Retail/Wholesale";
translations["MSG_INDUSTRY_HEALTHCARE"] = "Healthcare";
translations["MSG_INDUSTRY_EDUCATION"] = "Education";
translations["MSG_INDUSTRY_GOVERNMENT"] = "Government";
translations["MSG_INDUSTRY_REAL_ESTATE"] = "Real Estate";
translations["MSG_INDUSTRY_CONSTRUCTION"] = "Construction";
translations["MSG_INDUSTRY_TRANSPORTATION"] = "Transportation/Logistics";
translations["MSG_INDUSTRY_MEDIA"] = "Media/Advertising";
translations["MSG_INDUSTRY_SERVICE"] = "Service Industry";
translations["MSG_INDUSTRY_OTHER"] = "Other";
translations["MSG_JOB_TITLE_LABEL"] = "Job Title";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "Executive / Board Member";
translations["MSG_JOB_TITLE_MANAGER"] = "Manager";
translations["MSG_JOB_TITLE_GENERAL"] = "General Staff";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "Professional";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "No Title (Homemaker)";
translations["MSG_JOB_TITLE_STUDENT"] = "No Title (Student)";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "No Title (Unemployed)";
translations["MSG_LOADING"] = "Loading...";
translations["MSG_NEXT_BTN_BY_PARENT"] = "Next";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "Notification";
translations["MSG_OCCUPATION_TITLE"] = "Occupation";
translations["MSG_OCCUPATION_EXECUTIVE"] = "Executive";
translations["MSG_OCCUPATION_MANAGER"] = "Manager";
translations["MSG_OCCUPATION_ENGINEER"] = "Engineer";
translations["MSG_OCCUPATION_SALES"] = "Sales";
translations["MSG_OCCUPATION_MARKETING"] = "Marketing";
translations["MSG_OCCUPATION_HR"] = "Human Resources";
translations["MSG_OCCUPATION_ACCOUNTING"] = "Accounting/Finance";
translations["MSG_OCCUPATION_RESEARCHER"] = "Researcher";
translations["MSG_OCCUPATION_TEACHER"] = "Teacher";
translations["MSG_OCCUPATION_DOCTOR"] = "Doctor";
translations["MSG_OCCUPATION_NURSE"] = "Nurse";
translations["MSG_OCCUPATION_LAWYER"] = "Lawyer";
translations["MSG_OCCUPATION_DESIGNER"] = "Designer";
translations["MSG_OCCUPATION_FREELANCE"] = "Freelance";
translations["MSG_OCCUPATION_HOMEMAKER"] = "Homemaker";
translations["MSG_OCCUPATION_STUDENT"] = "Student";
translations["MSG_OCCUPATION_OTHER"] = "Other";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "View Plans";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "Sending images is available with the Premium Plan.\nUpgrade to Premium to send images.";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "About Image Feature";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "Select";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "Back";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "Confirm";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "Create";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "Next";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "Create again";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "Female";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "Male";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "Choose icon method";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "Preset\nicons";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "Choose an icon";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "Is this icon okay?";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "Creating icon...";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "Create with AI\nfrom your\nprofile";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "Upload\nimage";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_10M"] = "5M-10M JPY";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_10M"] = "Over 10M JPY";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "Prefer not to say";
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "Annual Income";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_5M"] = "Under 5M JPY";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG, PNG format, up to 5MB";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "Choose image";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "Upload Image";
translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "Account Actions";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "Account Created";
translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "Account";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "Account Status";
translations["MSG_PARENT_PAGE_ACTIVE"] = "Active";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "Chatted with Mana Pal";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "Rated the app ★%{rating}";
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "Cleared %{course} Stage %{stage} Level %{level}!";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "Activity";
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "Received a like";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "Sent feedback";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "Changed icon";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "Sent an inquiry";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "Logged in";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = 'Created "%{name}"';
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = 'Liked "%{name}"';
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = 'Published "%{name}"';
translations["MSG_PARENT_PAGE_ADD"] = "Add";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] =
  "You can add up to {{limit}} users on this plan.\nUpgrade your plan to add more users.";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "Cannot add user";
translations["MSG_PARENT_PAGE_AGE"] = "Age";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "Talk with Mana Pal";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "Answers questions and provides advice";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] =
  "A conversation experience that nurtures your child's curiosity";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "Discuss your ideas";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "Chat with Mana Pal";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "8/day";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "AI Chat History";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "No chat history yet";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count} messages";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "No messages";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "No title";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "Unlimited";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "Unlimited";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "Have fun chatting with an AI character!";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "Create with AI";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "Create original icons";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "Use in 'Create Freely'";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "Can also send in chat";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AI Image Generation";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2/day";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "Unlimited (3 images at a time)";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "10/day";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "Turn your imagination into images!";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] =
  "Use the parent app to check your child's learning progress and manage settings.";
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "Basic Info";
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "Billing Period";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "Birthday";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "Change Birthday";
translations["MSG_PARENT_PAGE_CHANGE"] = "Change";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "Change Password";
translations["MSG_PARENT_PAGE_STORAGE_FEATURE"] = "Data Storage";
translations["MSG_PARENT_PAGE_STORAGE_FREE_LIMIT"] = "1GB";
translations["MSG_PARENT_PAGE_STORAGE_STANDARD_LIMIT"] = "5GB";
translations["MSG_PARENT_PAGE_STORAGE_PREMIUM_LIMIT"] = "50GB";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AI Images";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "Album";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "Asset List";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "No assets yet";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "Asset List";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "Created";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "Size";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "Unnamed";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "Apps";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "No apps yet";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = " copies";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "Created";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = " likes";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "Published";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "Private";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "Updated";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = " views";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "More";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "Sketchbook";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "Enter a new name";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "Change Name";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "Bug report";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "How to use";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "Other";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "Feature request";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "Copy Permission";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "Allowed Content (Cassettes)";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "Enter Auth Code";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "If you have a 'Manande Puzzle' authentication code (corporate partnership code), please enter the specified code below.";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "Corporate Code";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "Confirm";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] =
  "If you have a corporate partnership code, please enter it here.";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] = "No additional allowed content (cassettes).";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "View Course Answers";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "Courses Completed";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "Account Created";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "Projects Created";
translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "Current Plan";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "Danger Zone";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM/DD";
translations["MSG_PARENT_PAGE_DAY"] = "Day";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "Delete";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "Delete this user";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] =
  "{{name}} will be deleted and all data (progress, projects, etc.) will be lost.\nThis action cannot be undone.";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] =
  "At least 1 user is required.\nAdd another user before deleting.";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "Cannot delete user";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "Delete user?";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "All learning data and projects will be deleted. This action cannot be undone.";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "Language";
translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "Download Parent App";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "Edit Best Subject";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "Edit Body Type";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "Edit Face Shape";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "Edit Favorite Colors";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "Edit Glasses";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "Edit Hairstyle";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "Edit Self Introduction";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] =
  "You are on a corporate contract. Please contact your administrator for details.";
translations["MSG_PARENT_PAGE_EMAIL"] = "Email";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "Email Verification";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "Enter Corporate Auth Code";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "Feedback Detail";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "Feedback History";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "No feedback yet";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "Pending";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "Rated app ★%{rating}";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "Replied";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "Inquiry";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "Feedback";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "App Rating";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "This player is frozen and cannot be switched to. Please activate the player first.";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "Cannot Switch";
translations["MSG_PARENT_PAGE_GENDER"] = "Gender";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "Change Gender";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Google Account";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "Hiragana";
translations["MSG_PARENT_PAGE_ICON"] = "Icon";
translations["MSG_PARENT_PAGE_INACTIVE"] = "Inactive";
translations["MSG_PARENT_PAGE_KANJI"] = "Kanji";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "Select display language";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "Change Language";
translations["MSG_PARENT_PAGE_LANGUAGE_EN"] = "English";
translations["MSG_PARENT_PAGE_LANGUAGE_JA"] = "Japanese";
translations["MSG_PARENT_PAGE_LANGUAGE_ZH_CN"] = "Simplified Chinese";
translations["MSG_PARENT_PAGE_LANGUAGE_ZH_TW"] = "Traditional Chinese";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "Learning Support";
translations["MSG_PARENT_PAGE_LINK"] = "Link";
translations["MSG_PARENT_PAGE_LOGOUT"] = "Logout";
translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "Type a message...";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "Load more";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "No messages yet";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "No chat rooms available";
translations["MSG_PARENT_PAGE_MONTH"] = "Month";
translations["MSG_PARENT_PAGE_NICKNAME"] = "Nickname";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "Please enter your new nickname";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "Change Nickname";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "Please try a different name";
translations["MSG_PARENT_PAGE_NOT_SET"] = "Not set";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "No activity in the last 24 hours";
translations["MSG_PARENT_PAGE_PEOPLE"] = " users";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "Plan Comparison";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "Plan Info";
translations["MSG_PARENT_PAGE_PLAN_SCOPE_ACCOUNT"] = "Account-wide";
translations["MSG_PARENT_PAGE_PLAN_SCOPE_PLAYER"] = "Per Player";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "Playable";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "Basic Information";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "Additional Notes";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "Not set";
translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "Profile Information";
translations["MSG_PARENT_PAGE_USAGE_SECTION_TITLE"] = "Usage";
translations["MSG_PARENT_PAGE_USAGE_PLAYERS"] = "Players";
translations["MSG_PARENT_PAGE_USAGE_STORAGE"] = "Data Storage";
translations["MSG_PARENT_PAGE_USAGE_CHAT_HISTORY"] = "Chat History";
translations["MSG_PARENT_PAGE_USAGE_ITEMS"] = " items";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "Failed to update profile";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "Profile updated successfully";
translations["MSG_PARENT_PAGE_PROJECTS"] = " projects";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = '"Create Freely" Projects';
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "Project Visibility";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "Published Projects";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "Likes Received";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "Recent Activity";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "Activity in last 24 hours";
translations["MSG_PARENT_PAGE_SETTINGS"] = "Settings";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "Account Linking";
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "Purchase Method";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "Suspended";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = 'Switch to "%{name}".';
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "Switch Player?";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "Switch";
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "Account";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "Avatar";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "Basic Info";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "Player";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "Personality";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "Messages";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "Notifications";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "Other";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "Billing";
translations["MSG_PARENT_PAGE_TODAY"] = "Today";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "Unlimited";
translations["MSG_PARENT_PAGE_UNLINK"] = "Unlink";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "Purchase Plan";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "Players";
translations["MSG_PARENT_PAGE_VERIFIED"] = "Verified";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "View Tutorial";
translations["MSG_PARENT_PAGE_YEAR"] = "Year";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = " years old";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "Yesterday";
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "Avatar";
translations["MSG_PARENT_PROFILE_FAMILY"] = "Family";
translations["MSG_PARENT_PROFILE_REGION"] = "Region";
translations["MSG_PARENT_PROFILE_WORK"] = "Work";
translations["MSG_PLAN_BUILDER_PARENT"] = "Builder";
translations["MSG_PLAN_EDUCATION_PARENT"] = "Education";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "Free Plan";
translations["MSG_PLAN_FREE_PARENT"] = "Free";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "Premium Plan";
translations["MSG_PLAN_PREMIUM_PARENT"] = "Premium";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "Standard Plan";
translations["MSG_PLAN_STANDARD_PARENT"] = "Standard";
translations["MSG_PREFECTURE_TITLE"] = "Prefecture";
translations["MSG_PROFILE_AI_BEST_SUBJECTS_BY_PARENT"] = "Best Subjects";
translations["MSG_PROFILE_AI_BODY_TYPE_BY_PARENT"] = "Body Type";
translations["MSG_PROFILE_AI_FACE_SHAPE_BY_PARENT"] = "Face Shape";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "Favorite Color";
translations["MSG_PROFILE_AI_GLASSES"] = "Glasses";
translations["MSG_PROFILE_AI_HAIRSTYLE_BY_PARENT"] = "Hairstyle";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER_BY_PARENT"] = "Tell us about your child";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY_BY_PARENT"] = "Birthday";
translations["MSG_PROFILE_SUBSTEP_GENDER_BY_PARENT"] = "Gender";
translations["MSG_PROFILE_SUBSTEP_ICON_BY_PARENT"] = "Icon";
translations["MSG_PROFILE_STEP_GENDER_DESC"] = "Please select your gender.";
translations["MSG_PROFILE_STEP_BIRTHDAY_DESC"] = "Please select your birthday.";
translations["MSG_PROFILE_STEP_APPEARANCE_DESC"] = "Please select the closest option.";
translations["MSG_PROFILE_STEP_WORK_DESC"] = "Please select your workplace.";
translations["MSG_PROFILE_STEP_REGION_DESC"] = "Please select your prefecture and area.";
translations["MSG_PROFILE_STEP_FAMILY_DESC"] =
  "Please select your household members (multiple answers allowed).";
translations["MSG_REAUTH_BACK"] = "Back";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] =
  "A password reset email will be sent to the following address";
translations["MSG_REAUTH_SSO_MESSAGE"] = "Please sign in again to continue";
translations["MSG_REAUTH_TITLE"] = "Identity Verification";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "View Plans";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "Difficult to use";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "Don't know\nhow to use";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "Too difficult";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "Too easy";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "Too few\nstages";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "Too many\nstages";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "Can't create\nwell";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "Difficult to\nuse";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "No complaints";
translations["MSG_SELECT_PLACEHOLDER_BY_PARENT"] = "Please select";
translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "Go to 'Manande Puzzle' site";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "Contact Us";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "Privacy Policy";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "Terms of Service";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "Cannot suspend the currently logged-in user.\nPlease switch to another user before suspending this user.";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "Cannot Change";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "The maximum number of active users is 4.\nTo activate this user, please deactivate (or delete) another unnecessary user.";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "Cannot Activate";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "At least one user is required.\nCannot reduce the number of users further.";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "Cannot Change";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] = "Suspend play for this user.";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "Suspend Play";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] = "Resume play for this user.";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "Resume Play";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "Authentication Code";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "Social account is already linked to another account.";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] = "Cannot Link";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "Delete Account";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "Logging out of the account will prevent you from playing with the current user.\nUser information is saved in the account, so if you want to play with the same user again, please log in again with this account.";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "Log Out";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] =
  "Please tell us the reason for deleting your account.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "Deleting the account will remove all data including the account and users.\nAccount deletion cannot be recovered. Please be careful.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] = "Delete your account?";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "Deleting your account from 'Manande Puzzle' will delete all of the following data:\n・Registered profile and account information.\n・Registered user information for everyone.\n・Apps created by users in 'Create Freely'.\n・All grades and clear achievements for 'Learn with Courses' cleared by users.\n・'Talk History' etc. conducted by users.\n* 【Important】Deleting the logged-in account will delete all data related to this account, so please be very careful.\n* 【Important】This operation cannot be recovered under any circumstances. Please be very careful when deleting your account.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【Important】Please Note";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "Corporate Authentication";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "View Course Answers";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "Current Password";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "New Password";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "Confirm Password";
translations["MSG_SIGN_EMAIL_SENT"] = "Email sent";
translations["MSG_SIGN_IN_BTN"] = "Log In";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] = "Incorrect password entered.";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "Password changed successfully.";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "Incorrect email address or password.";
translations["MSG_SIGN_IN_FAILED_TITLE"] = "Login Failed";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "Forgot Password?";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "Login successful.";
translations["MSG_SIGN_IN_WITH_APPLE"] = "Continue with Apple";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "Continue with Google";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] =
  "Failed to send password reset email. Please try again.";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "Send Reset Email";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "A password reset email will be sent to the following address.";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] = "A password reset email has been sent.";
translations["MSG_CLOSE_BTN_BY_PARENT"] = "Close";
translations["MSG_SIGN_USER_PASSWORD"] = "Password";
translations["MSG_SUBJECT_ART_BY_PARENT"] = "Art";
translations["MSG_SUBJECT_ENGLISH_BY_PARENT"] = "English";
translations["MSG_SUBJECT_ETHICS_BY_PARENT"] = "Ethics";
translations["MSG_SUBJECT_HOME_EC_BY_PARENT"] = "Home Economics";
translations["MSG_SUBJECT_JAPANESE_BY_PARENT"] = "Japanese";
translations["MSG_SUBJECT_MATH_BY_PARENT"] = "Math";
translations["MSG_SUBJECT_MUSIC_BY_PARENT"] = "Music";
translations["MSG_SUBJECT_PE_BY_PARENT"] = "P.E.";
translations["MSG_SUBJECT_PROGRAMMING_BY_PARENT"] = "Programming";
translations["MSG_SUBJECT_SCIENCE_BY_PARENT"] = "Science";
translations["MSG_SUBJECT_SOCIAL_BY_PARENT"] = "Social Studies";
translations["MSG_SUBSCRIPTION_ANNUAL_BADGE"] = "2 months free!";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "Annual";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "Annual Plan";
translations["MSG_SUBSCRIPTION_DISCOUNT_BADGE"] = "Family Support";
translations["MSG_SUBSCRIPTION_MANAGE"] = "Manage Subscription";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] =
  "Please manage your subscription purchased on App Store through App Store";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] =
  "Please manage your subscription purchased on Google Play through Google Play";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "Monthly";
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "Monthly Plan";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] =
  "This subscription was purchased on a different platform";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "Purchased on another platform";
translations["MSG_SUBSCRIPTION_AMAZON_NOT_SUPPORTED_TITLE"] = "Purchase not available on Amazon";
translations["MSG_SUBSCRIPTION_AMAZON_NOT_SUPPORTED_MESSAGE"] =
  "Purchase is not available on the Amazon app. Please access Manande Puzzle from a web browser and log in with the same account to make a purchase.";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "Failed to open portal";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "Purchase";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "Purchase failed. Please try again.";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "Purchase completed!";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "Subscription Management";
translations["MSG_TOAST_DELETED_SUCCESS"] = "Deleted successfully";
translations["MSG_TOAST_EDIT_SUCCESS"] = "Changed successfully";
translations["MSG_TOAST_ERROR"] = "An error occurred";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "File is too large";
translations["MSG_TOAST_SEND_FAILED"] = "Send failed";
translations["MSG_UPLOAD_ICON_HINT_BY_PARENT"] = "JPG, PNG format, up to 5MB";
translations["MSG_UPLOAD_ICON_SELECT_BY_PARENT"] = "Select Image";
translations["MSG_UPLOAD_ICON_TITLE_BY_PARENT"] = "Upload Image";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "Please enter a name within 10 characters";
translations["MSG_USER_NAME_REQUIRED"] = "Please enter your name";
translations["MSG_PARENT_PAGE_PLAYER_EMPTY_TITLE"] = "No players";
translations["MSG_PARENT_PAGE_PLAYER_EMPTY_MESSAGE"] = "Add a child to start learning";
translations["MSG_PARENT_PAGE_PLAYER_ADD_BTN"] = "Add Player";
translations["MSG_PARENT_PAGE_LAUNCH_APP"] = "Launch App";
translations["MSG_PARENT_PAGE_NO_PLAYER_WARNING_TITLE"] = "No Player";
translations["MSG_PARENT_PAGE_NO_PLAYER_WARNING_MESSAGE"] =
  "Please add a player first to launch the app.";

// CreatePlayerModal
translations["MSG_PARENT_PAGE_CREATE_PLAYER_TITLE"] = "Add Player";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_ICON_TITLE"] = "Select Icon";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_CONFIRM_TITLE"] = "Confirm";
translations["MSG_TOAST_CREATE_PLAYER_SUCCESS"] = "Player added successfully";
translations["MSG_CREATE_USER_PREVIEW_MESSAGE_BY_PARENT"] = "Register player with this information";
translations["MSG_PRESET_ICON_TITLE_BY_PARENT"] = "Choose an icon";
translations["MSG_ICON_CATEGORY_ALL_BY_PARENT"] = "All";
translations["MSG_UPLOAD_ICON_DRAG_DROP_BY_PARENT"] = "Drag & drop an image here";
translations["MSG_UPLOAD_ICON_CLICK_BY_PARENT"] = "Or click to select an image";
translations["MSG_UPLOAD_ICON_REMOVE_BY_PARENT"] = "Remove";
translations["MSG_UPLOAD_ICON_TYPE_ERROR"] = "Please select a JPG or PNG image";
translations["MSG_UPLOAD_ICON_SIZE_ERROR"] = "File size must be 5MB or less";
translations["MSG_SELECT_PLACEHOLDER"] = "Please select";
translations["MSG_COLOR_SELECT_SHADE_BY_PARENT"] = "Choose a shade you like";
translations["MSG_PROFILE_AI_APPEARANCE_BY_PARENT"] = "Appearance";

// CreatePlayerModal - additional keys (copied from main i18n)
translations["MSG_CREATE_USER_TITLE_GENDER_BY_PARENT"] = "Your child's gender";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY_BY_PARENT"] = "Your child's birthday";
translations["MSG_CREATE_USER_TITLE_PREVIEW_BY_PARENT"] = "Confirm Registration";
translations["MSG_CREATE_USER_BTN_NEXT_BY_PARENT"] = "Next";
translations["MSG_CREATE_USER_BTN_GENERATE_BY_PARENT"] = "Create Icon";
translations["MSG_CREATE_USER_STEP_NAME_BY_PARENT"] = "Name";
translations["MSG_CREATE_USER_STEP_ICON_BY_PARENT"] = "Icon";
translations["MSG_CREATE_USER_STEP_CONFIRM_BY_PARENT"] = "Confirm";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "Name%{random}";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT_BY_PARENT"] = "Enter your child's name";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_BY_PARENT"] = "Favorite color";
translations["MSG_SUBJECT_LANGUAGE_BY_PARENT"] = "Language Arts";
translations["MSG_SUBJECT_LIFE_BY_PARENT"] = "Life Studies";
translations["MSG_SUBJECT_INTEGRATED_BY_PARENT"] = "Integrated Studies";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES_BY_PARENT"] = "Special Activities";

// CreatePlayerModal - step bar labels
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_NAME"] = "Name";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_LANGUAGE"] = "Language";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_ICON"] = "Icon";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_CONFIRM"] = "Confirm";
translations["MSG_CREATE_USER_TITLE_LANGUAGE_BY_PARENT"] = "Select display language for your child";
translations["MSG_USER_PROFILE_NAME_PLACEHOLDER_BY_PARENT"] = "Child's name";

// CreatePlayerModal - substep labels (6 steps)
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_GENDER"] = "Gender";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_BIRTHDAY"] = "Birthday";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_APPEARANCE"] = "Appearance";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_COLOR"] = "Favorite Color";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_BEST_SUBJECT"] = "Best Subjects";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_ICON"] = "Icon";

// Asset deletion
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_BTN"] = "Delete";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_TITLE"] = "Delete this asset?";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_MESSAGE"] =
  '"%{name}" will be deleted.\nThis action cannot be undone.';

// Auth screens
translations["MSG_SIGN_IN_WITH_MAIL"] = "Log in with email";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "Don't have an account? Sign up";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "Please enter your password";
translations["MSG_SIGN_LOGIN_FAILED"] = "Incorrect email address or password.";
translations["MSG_SIGN_UP_BTN"] = "Sign Up";
translations["MSG_SIGN_UP_WITH_MAIL"] = "Sign up with email";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "Already have an account? Log in";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "Passwords do not match";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "This email is already registered. Please try another email address.";
translations["MSG_SIGN_UP_FAILED"] = "Failed to create account. Please try again.";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "Account created successfully.";
translations["MSG_SIGN_UP_WITH_APPLE"] = "Continue with Apple";
translations["MSG_SIGN_USER_MAIL"] = "Email";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "Confirm Password";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "Please enter your email address";
translations["MSG_SIGN_EMAIL_INVALID"] = "Please enter a valid email address";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "Reset Password";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "Back to Login";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "Parent";

// Delete Account Modal
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_DESC_PREFIX"] =
  "If you wish to delete your registered account, please click ";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_CLICK_HERE"] = "here";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_DESC_SUFFIX"] = ".";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_1"] =
  "I don't use it (regularly) anymore";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_2"] = "Lack of content";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_3"] = "The app was difficult to use";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_4"] = "Startup and play speed was slow";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_5"] = "Notifications were annoying";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_6"] = "Other";
translations["MSG_NEXT_BTN"] = "Next";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FEEDBACK_LABEL"] =
  "Please share any other feedback (optional)";

// Auth screens - Back to Onboarding button
translations["MSG_AUTH_BACK_TO_START"] = "Back to Start";

// Plan comparison table - Player count
translations["MSG_PARENT_PAGE_USERS_FREE"] = "2";
translations["MSG_PARENT_PAGE_USERS_STANDARD"] = "4";
translations["MSG_PARENT_PAGE_USERS_PREMIUM"] = "8";

// Restore purchases
translations["MSG_SUBSCRIPTION_RESTORE_BTN"] = "Restore Purchases";
translations["MSG_SUBSCRIPTION_RESTORE_SUCCESS_TITLE"] = "Restore Complete";
translations["MSG_SUBSCRIPTION_RESTORE_SUCCESS_MESSAGE"] = "Your purchases have been restored";

// Parent profile - Your role
translations["MSG_USER_ROLE_TITLE"] = "You";

// Accessories
translations["MSG_ACCESSORY_TITLE_BY_PARENT"] = "Accessories";
translations["MSG_ACCESSORY_NONE_BY_PARENT"] = "None";
translations["MSG_ACCESSORY_MEGANE_BY_PARENT"] = "Glasses";
translations["MSG_ACCESSORY_BOUSHI_BY_PARENT"] = "Hat";
translations["MSG_ACCESSORY_HAIRPIN_BY_PARENT"] = "Hairpin";
translations["MSG_ACCESSORY_RIBBON_BY_PARENT"] = "Ribbon";
translations["MSG_ACCESSORY_BANDAID_BY_PARENT"] = "Bandaid";
translations["MSG_PARENT_PAGE_EDIT_ACCESSORY"] = "Edit Accessories";

// Parent Registration Promotion
translations["MSG_PARENT_REGISTRATION_TITLE"] = "Sign Up";
translations["MSG_PARENT_REGISTRATION_OVERLAY_HINT"] = "Parent registration required";
translations["MSG_TRIAL_DATA_NOT_CLAIMED"] =
  "The signed-in account has reached its player limit, so your trial player was not transferred.";

export default translations;
